var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('title-row', {
    attrs: {
      "title": "Ütemzések",
      "subtitle": _vm.dataTable.itemsLength === -1 ? 'Betöltés...' : `${_vm.dataTable.itemsLength} ütemzés van a rendszerben`,
      "breadcrumb-items": [{
        text: 'Ütemzések',
        disabled: true
      }]
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.hasRight('SCHEDULE_WRITE') ? _c('title-row-button', {
          attrs: {
            "to": {
              name: 'NewSchedule'
            },
            "title": "Hozzáadás"
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" Új ütemzés ")], 1) : _vm._e()];
      },
      proxy: true
    }])
  }), _c('v-expansion-panels', {
    staticClass: "mb-4 rounded-xl overflow-hidden",
    attrs: {
      "mandatory": !!Object.values(_vm.search).find(function (e) {
        return e !== '';
      }),
      "flat": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('span', {
    staticClass: "font-weight-medium"
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v(" Keresés ")], 1)]), _c('v-expansion-panel-content', [_c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": 12,
      "md": 4
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Megnevezés",
      "dense": "",
      "clearable": "",
      "hide-details": "",
      "filled": ""
    },
    on: {
      "input": _vm.searchEventHandler
    },
    model: {
      value: _vm.search.name,
      callback: function ($$v) {
        _vm.$set(_vm.search, "name", $$v);
      },
      expression: "search.name"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.dataTable.headers,
      "items": _vm.dataTable.items,
      "server-items-length": _vm.dataTable.itemsLength,
      "options": _vm.dataTable.options,
      "footer-props": _vm.$config.dataTableFooterProps
    },
    on: {
      "update:options": function ($event) {
        return _vm.$set(_vm.dataTable, "options", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: `item.access_level_schedule`,
      fn: function (_ref) {
        var item = _ref.item;
        return [item.access_level_schedule.length === 0 ? _c('span', {
          staticClass: "red--text"
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "error"
          }
        }, [_vm._v("mdi-close")])], 1) : _c('span', {
          staticClass: "green--text"
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "success"
          }
        }, [_vm._v("mdi-check")])], 1)];
      }
    }, {
      key: `item.access_level`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return _vm._l(item.access_level, function (accessLevel, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-1",
            attrs: {
              "small": ""
            }
          }, [_vm._v(" " + _vm._s(accessLevel.name) + " ")]);
        });
      }
    }, {
      key: `item.actions`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('div', {
          staticClass: "d-flex justify-center"
        }, [_vm.hasRight('SCHEDULE_WRITE') ? _c('v-btn', {
          staticClass: "rounded-sm mx-2",
          attrs: {
            "text": "",
            "fab": "",
            "small": "",
            "dark": "",
            "color": "primary",
            "to": {
              name: 'ScheduleEditor',
              params: {
                id: item.id
              }
            },
            "title": "Szerkesztés"
          }
        }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1) : _vm._e(), _vm.hasRight('SCHEDULE_DELETE') ? _c('v-btn', {
          staticClass: "rounded-sm mx-2",
          attrs: {
            "text": "",
            "fab": "",
            "small": "",
            "dark": "",
            "color": "primary",
            "title": "Törlés"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteSchedule(item);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-delete")])], 1) : _vm._e()], 1)];
      }
    }], null, true)
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }